export default function FunPanel({ onAddRandom, onSeeList, disabled }) {
  return (
    <div className="fun-panel" style={{ width: "min(100%, 320px)", boxSizing: "border-box" }}>
      <h2 style={{ color: "white" }}>Fun</h2>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button type="button" className="names-btn primary" onClick={onAddRandom} disabled={disabled}>
          Add random thing
        </button>
        <button type="button" className="names-btn secondary" onClick={onSeeList} disabled={disabled}>
          See list
        </button>
      </div>
    </div>
  );
}
